<template>
    <div id="workflow" class="mb-5">
        <div class="stepsArea scrollable" v-if="showSteps">
            <div id="added-step"  v-for="(step, key, index) in stepsObject['sequence']" :key="index">
                <div v-if="stepsObject['steps'][step].id=='completed'">
                    <div class="line-in-middle d-block"></div>
                    <div id="new-step" class="text-center">
                        <button type="button" class="addStepBtn" data-toggle="modal" data-target="#addStep">
                            <i class="fa fa-plus f-14"></i>
                        </button>
                        <div class="line-in-middle d-block"></div>
                    </div>
                </div>
                <div v-if="stepsObject['steps'][step].id !== 'completed' && stepsObject['steps'][step].id !== 'start'" class="line-in-middle d-block"></div>
                <div class="card d-block" style="width: 18rem;">
                    <div v-if="stepsObject['steps'][step].id == 'start'" style="background-color: #009FF7; height:8px; border-top-left-radius:4px; border-top-right-radius:4px;"></div>
                    <div class="card-body">
                        <h5 class="card-title" v-if="stepsObject['steps'][step].id == 'completed'" style="color:#4A9438;">{{stepsObject['steps'][step].name}}</h5>
                        <h5 class="card-title" v-else>{{stepsObject['steps'][step].name}}</h5>
                        <p class="card-text" v-if="stepsObject['steps'][step].id == 'start'">{{$ml.get('START_STEP')}}</p>
                        <p class="card-text" v-else-if="stepsObject['steps'][step].id == 'completed'">{{$ml.get('COMPLETED_STEP')}}</p>
                        <p class="card-text" v-else>{{$ml.get('STEP_DESCRIPTION')}}</p>
                        <button class="btn btn-light" @click="updateStep(stepsObject['steps'][step])">{{$ml.get('CHANGE')}}</button>
                    </div>
                    <div v-if="stepsObject['steps'][step].id == 'completed'" style="background-color: #4A9438; height:8px; border-bottom-left-radius:4px; border-bottom-right-radius:4px;"></div>
                </div>
            </div>
            <div class="pageFooter mb-2">
                <div class="container d-flex justify-content-end pt-1">
                    <button class="btn btn-light mr-1 px-3 bg-white" @click="changePage('form')"><i class="far fa-arrow-left mr-2" style="font-weight:700;"></i>{{this.$ml.get('BACK')}}</button>
                    <button class="btn btn-primary px-4" @click="changePage('permission')">{{this.$ml.get('CONTINUE')}}<i class="far fa-arrow-right ml-2" style="font-weight:700;"></i></button>
                </div>
            </div>
        </div>
        

        <!---------- ADD STEP MODAL --------->
        <div class="modal fade" id="addStep" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="headerButtons col-11">
                            <input type="text" class="stepName" placeholder="Enter step name" v-model="stepName">
                            <button type="button" class="btn deleteBtn" @click="deleteStep"><span class="fa fa-trash" style="color:#99ACC2;"></span></button>
                        </div>
                        <div class="col-1 p-0">
                            <button type="button" class="btn btn-close ml-1 d-flex align-items-center" @click="showSteps=true" data-dismiss="modal" aria-label="Close">X</button>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div>
                            <label style="color:#7F8FA4; font-weight:500;">{{this.$ml.get('ASSIGNED')}}*</label>
                            <div id="multi-select">
                                <multiselect v-model="value" tag-placeholder="Add this as new tag" placeholder="Search or add a tag" label="name" track-by="name" :options="options" :multiple="true" :taggable="false" :close-on-select="false"></multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="clear">{{this.$ml.get('CANCEL')}}</button>
                        <button type="button" class="btn btn-primary" @click="save">{{this.$ml.get('SAVE')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'
import {v4 as uuidv4} from 'uuid';
import FormPermissions from './formGeneratorPermissions.vue'

Vue.component('multiselect', Multiselect)

export default {
    name: "FormGeneratorFlow",
    components: {
        Multiselect,
        FormPermissions 
    },
    props: ['formConfiguration','flow'],
    data () {
        return {
            users: [],
            stepsObject: {
                'steps':{
                    'start':{
                      assignees:[],
                      id:'start',
                      name:this.$ml.get('START') 
                    },
                    'completed':{
                      assignees:[],
                      id:'completed',
                      name:this.$ml.get('COMPLETED')  
                    }
                },
                'sequence':[
                    'start',
                    'completed'
                ]
            },
            stepName: '',
            value: [],
            options: [],
            showPermissions: false,
            currentStepId: '',
            showSteps: true
        }
    },  
    computed:{
        ...mapState([
            'baseUrl'
        ]),
    },
    created() {
        this.$root.$refs.formGeneratorFlow = this
    },
    methods: {
        updateStep(step) {
            this.showSteps = false
            this.stepName = step.name
            this.value = step.assignees
            this.currentStepId = step.id

            for(let item of step.assignees){
                if(item.value === "admin" || item.value === "manager" || item.value === "normal"){
                    item.name = item.value.charAt(0).toUpperCase() + item.value.slice(1)
                }
                else if( item.type === "creator" ){
                    item.name = item.type.charAt(0).toUpperCase() + item.type.slice(1)
                }
                else{
                    for(let user of this.users){
                        if(item.value === user._id.$oid){
                            item.name = user.name + ' ' + user.surName
                        }
                    }
                }
            }

            $('#addStep').modal('show')
        },
        deleteStep() {
            for(var i=0; i<this.stepsObject.sequence.length; i++) {
                if(this.stepsObject.sequence[i] === this.currentStepId) {
                    this.stepsObject.sequence.splice(i, 1)
                    delete this.stepsObject.steps[this.currentStepId]
                    $('#addStep').modal('hide')
                    this.$emit("flow", this.stepsObject)
                    this.showSteps = true
                }
            }
        },
        save() {
            let arr = [], isUpdateStep=false
            
            if(this.stepName == ""){
                this.$notify({
                    group: "foo",
                    type: "warn",
                    title: "Lütfen aşama adı giriniz!",
                });
            }
            else if(this.value.length==0){
                this.$notify({
                    group: "foo",
                    type: "warn",
                    title: "Lütfen bir kişi seçiniz!",
                });
            }
            else{
                for(let user of this.value){
                    let userObj = {}
                    userObj.value = user.value
                    userObj.type = user.type
                    arr.push(userObj)
                }

                for(var key in this.stepsObject.steps){
                    if(this.currentStepId === this.stepsObject.steps[key].id){
                        isUpdateStep = true
                    }
                }

                if(isUpdateStep==true) {
                    let updateStepObj = this.stepsObject.steps[this.currentStepId]
                    updateStepObj.name = this.stepName
                    updateStepObj.assignees = arr
                }
                else{
                    var uuid = 'step_' + uuidv4()
                    let stepObj = {}
                    stepObj.name = this.stepName
                    stepObj.id = uuid
                    stepObj.assignees = arr 
                    this.stepsObject['steps'][uuid] = stepObj
                    this.stepsObject['sequence'].splice(this.stepsObject['sequence'].length-1, 0, uuid)
                    for(var key in this.stepsObject.steps){
                        if('completed' === this.stepsObject.steps[key].id){
                            let tempObj = this.stepsObject.steps[key]
                            delete this.stepsObject.steps[key]
                            this.stepsObject['steps']['completed'] = tempObj
                        }
                    }
                }
                
                $('#addStep').modal('hide')
                console.log(this.stepsObject)
                this.$emit("flow", this.stepsObject)
                this.clear()
            }

        },
        changePage(tab) {
            var steps = this.stepsObject['steps']

            if(tab === 'permission'){
                for(let item in steps){
                    if(steps[item].assignees.length == 0){
                        this.$notify({
                            group: "foo",
                            type: "warn",
                            title: "Lütfen tüm aşamalara kişi atayınız!",
                        });
                        return false
                    }
                }
            }

            this.$root.$refs.formGenerator.changeTab(tab)
        },
        clear() {
            this.stepName = ''
            this.currentStepId = ''
            this.value = []
            this.showSteps = true
        },
        getUsersF() {
            axios({
                method:'POST',
                url:'/getUsers',
                baseURL: this.baseUrl,
                data: {
                    showPassiveUsers:false
                },
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        this.users=res.data.content.users
                        let assignees = [
                            { name: 'Creator', type: 'creator', value: 'creator' },
                            { name: 'Manager', type: 'group', value: 'manager' },
                            { name: 'Admin', type: 'group', value: 'admin' },
                            { name: 'User', type: 'group', value: 'normal' }
                        ]

                        for(let user of this.users){
                            let obj = {}
                            obj.name = user.name + ' ' + user.surName
                            obj.type = 'user'
                            obj.value = user._id.$oid
                            assignees.push(obj)
                        }

                        this.options = assignees
                    }else{

                    }
                }else{
                    
                }
            })
        },
    },
    mounted() {
        this.getUsersF()
        this.stepsObject = this.flow
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    .stepsArea {
        height: 80vh;
    }
    .card {
        margin: 0 auto;
        min-height: 120px;
    }
    .pageFooter {
        display: flex;
        background: #fff;
        color: #333333CC;
        position: absolute;
        width: 100%;
        bottom: -6%;
        height: 70px;
        align-items: center;
        left: 0;
        border-top: 1px solid rgba(139, 146, 158, 0.5);
        z-index: 99;
    }
    #new-step {
        margin: 0 auto;
    }
    #completed-step {
        margin: 0 auto;
        width: 130px;
        padding: 8px;
        font-size: 16px;
        text-align: center;
        font-weight: 600;
        color: rgb(36, 151, 36);
        background: rgb(243, 255, 243);
        border: 1px solid rgb(31, 139, 31);
        border-radius: 20px;
    }
    .line-in-middle {
        height:30px;
	    background: linear-gradient(
            to right, 
            transparent 0%, 
            transparent calc(50% - 0.81px), 
            rgb(155, 155, 155) calc(50% - 0.2px), 
            rgb(155, 155, 155) calc(50% + 0.2px), 
            transparent calc(50% + 0.81px), 
            transparent 100%
        ); 
	}
    .addStepBtn{
        border: 2px solid #009FF7;
        color: #009FF7;
        border-radius: 50%;
        height: 30px;
        width: 30px;
        cursor: pointer;
    }
    .addStepBtn:hover {
        background: rgb(228, 228, 228);
    }
    .stepName {
        width: 90%;
        border: none;
        background: transparent;
        padding: 5px 5px;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
    }
    .stepName:focus, .stepName:hover {
        border-bottom: 1px dashed #AFC2D9;
    }
    .modal-header {
        background: #F3F6F9;
        border-bottom: 1px solid #AFC2D980;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.5rem 0.75rem;
    }
    .modal-body {
        padding: 2.5rem 1rem;
        background: #FAFAFA;
        border-bottom: 1px solid #AFC2D980;
    }
    .headerButtons {
        display: flex;
        justify-content: space-between;
        padding: 0;
    }
    .deleteBtn {
        background: transparent;
        font-size: 18px;
        border-right: 1px solid #AFC2D980;
        border-radius: 0px;
        padding: 0px 10px 0px 0px;
    }
    .btn-close {
        background: transparent;
        color: #99ACC2;
        font-size: 20px;
        padding: 0.2rem 0.75rem;
    }
    .btn-primary {
        padding: 0.4rem 2rem;
    }
    .btn-secondary {
        padding: 0.4rem 2rem;
        color: #000;
        background: transparent;
        border: none;
    }
    .btn-secondary:hover {
        background: #dfdfdf;
    }
    ::placeholder {
        color: #99ACC2;
        opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #99ACC2;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #99ACC2;
    }

    .scrollable {
        box-sizing: border-box;
        overflow-y: scroll;
        padding-bottom: 80px;
    }
    /* Hide scrollbar for Chrome, Safari and Opera */
    .scrollable::-webkit-scrollbar {
        display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    .scrollable {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
</style>

